export default "__VITE_ASSET__f276ae97__"